import {Panel, Variant} from './Panel'
import {PanelHeader} from './PanelHeader'
import {PanelBody} from './PanelBody'


export default Object.assign(Panel, {Header: PanelHeader, Body: PanelBody})

export { Variant }